// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { Suspense } from "react";

import { BrowserRouter } from "react-router-dom";

import { ApplicationProviders } from "./ApplicationProviders";
import { ApplicationRoutes } from "./routes";
import FullPageLoading from "./routes/user/components/FullPageLoading";
import { LoadingProvider } from "./routes/user/loadingContext";

const App = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Suspense fallback={<FullPageLoading />}>
      <ApplicationProviders>
        <LoadingProvider>
          <ApplicationRoutes />
        </LoadingProvider>
      </ApplicationProviders>
    </Suspense>
  </BrowserRouter>
);

export default App;
